import { Box, useTheme } from '@mui/material'
import { useCallback, useContext, useEffect, useRef, ReactNode } from 'react'
import { MapRenderContext } from 'src/contexts/MapRenderContext'

interface BottomSheetPaddedProps {
    children: ReactNode
}

const BottomSheetPadded = ({ children }: BottomSheetPaddedProps) => {
    const { map, mapRef, mapLoaded } = useContext(MapRenderContext)
    const theme = useTheme()

    const bottomSheetRef = useRef<Element>()
    const pullerRef = useRef<Element>()

    useEffect(() => {
        if (!mapLoaded) return
        mapRef!.current.style.height = bottomSheetRef.current.offsetTop + 'px'
        map!.current!.resize()
        return () => {
            mapRef!.current.style.height = '100%'
            map!.current!.resize()
        }
    }, [map, mapRef, mapLoaded, bottomSheetRef])

    // When drawer opens, clean up the map
    // TODO: move this somewhere more sensible or just manage map state properly

    const cleanUpMap = useCallback(() => {
        if (!map || !map.current || !map.current.getStyle()) return
        const cleanable_layers = ['trip-polyline']
        map?.current.getStyle().layers.forEach((layer) => {
            // console.log('layer', layer.id);
            if (cleanable_layers.includes(layer.id)) {
                map?.current!.removeLayer(layer.id)
                if (map?.current!.getSource(layer.id)) {
                    map?.current!.removeSource(layer.id)
                }
            }
        })
        const cleanable_sources = ['planView', 'planVehicleLocations', 'tripPolyline', 'vehicles']
        cleanable_sources.forEach((source) => {
            if (map?.current.getSource(source)) {
                console.log('cleaning source:', source)
                map?.current.getSource(source).setData({
                    type: 'FeatureCollection',
                    features: [],
                })
            }
            else {
                console.log('source not found:', source)
            }
        })
    }, [map])

    // Dismissed by swiping all the way down
    useEffect(() => {
        cleanUpMap()
    }, [cleanUpMap])

    return (
        <div
            ref={bottomSheetRef}
            style={{
                position: 'absolute',
                bottom: `calc(56px + env(safe-area-inset-bottom))`,
                width: '100%',
                height: '50%',
                background: `color-mix(in srgb, ${theme.palette.background.default} 90%, transparent)`,
                backdropFilter: 'blur(24px) saturate(1.6)',
                WebkitBackdropFilter: 'blur(24px) saturate(1.6)',
                borderRadius: '20px 20px 0 0',
                boxShadow: '0 -4px 32px rgba(0,0,0,0.1)',
                zIndex: 3,
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <div
                ref={pullerRef}
                style={{
                    width: '100%',
                    boxSizing: 'border-box',
                    padding: 10,
                    zIndex: 1100,
                    background: 'transparent',
                }}
            >
                <div style={{
                    width: '10vw',
                    height: 6,
                    borderRadius: 3,
                    margin: '0 auto',
                    // position: 'absolute',
                    // top: theme.spacing(1),
                    // left: 'calc(50% - 5vw)',
                    cursor: 'ns-resize',
                    zIndex: 1200,
                    backgroundColor: theme.palette.divider,

                }}
                >
                </div>
            </div>
            <Box sx={{ py: 2, overflowY: 'auto' }}>
                {children}
            </Box>
        </div>
    )
}

export default BottomSheetPadded
